module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325506/result01-f8d8d8bab3c4450a186d36eda8bdbd75.png";